import { render, staticRenderFns } from "./monitior1.vue?vue&type=template&id=b91d42d4&scoped=true"
import script from "./monitior1.vue?vue&type=script&lang=js"
export * from "./monitior1.vue?vue&type=script&lang=js"
import style0 from "./monitior1.vue?vue&type=style&index=0&id=b91d42d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91d42d4",
  null
  
)

export default component.exports